import { LocaleConstant } from '../en/constant'

import {
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_AGE,
  MIN_PASSWORD_LENGTH,
} from '@/constants/Common'

const constant: LocaleConstant = {
  emailInvalid: 'Alamat e-mel tidak sah.',
  emailRequired: 'E-mel adalah diperlukan.',
  passRequired: 'Kata laluan diperlukan.',
  passNoWhiteSpace: 'Ruang kosong tidak dibenarkan.',
  passMinLength: `Kata laluan mesti mengandungi sekurang-kurangnya ${MIN_PASSWORD_LENGTH} aksara.`,
  passMaxLength: `Kata laluan tidak boleh melebihi ${MAX_PASSWORD_LENGTH} aksara.`,
  passLettersNumbers: 'Kata laluan mesti mengandungi huruf dan angka',
  passOneNumbers: 'Kata laluan mesti mengandungi sekurang-kurangnya satu angka',
  passStrength: `Kata laluan minimum ${MIN_PASSWORD_LENGTH} aksara yang mengandungi kombinasi huruf besar atau kecil dan angka diperlukan.`,
  passMatch: 'Sila masukkan kata laluan yang sepadan.',
  fullNameRequired: 'Nama penuh diperlukan.',
  fullNameNoSpecial: 'Tiada nombor atau aksara khas yang dibenarkan.',
  fullNameNoWhitespace: 'Hanya ruang kosong yang tidak dibenarkan.',
  fullNameMaxLength: `Hanya ${MAX_FULL_NAME_LENGTH} aksara yang dibenarkan`,
  nameMaxLength: `Hanya ${MAX_NAME_LENGTH} aksara yang dibenarkan`,
  typeDate: 'Format tarikh haruslah MM/DD/YYYY.',
  birthDateRequired: 'Tarikh lahir diperlukan.',
  birthDateMin: `Umur minimum adalah ${MIN_AGE} tahun.`,
  emailConfirm: 'E-mel tidak sepadan.',
  locationRequired: 'Lokasi diperlukan',
  locationNeedsCity: 'Sila pilih bandar atau pekan. Negara sahaja tidak mencukupi.',
  locationSaveFailed: 'Kami tidak dapat menggunakan lokasi itu. Cuba lagi atau pilih lokasi lain.',
}

export default constant
